import { Box } from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import TkHeader from "../../molecules/TkHeader";
import "./_style.scss";
import TkFooter from "../../molecules/TkFooter";
import HandleErrorMessage from "../../molecules/TkMessageBar";
import { useLocation, useNavigate } from "react-router-dom";
import { useConcatRoutes } from "../../../routes/router";
import { GlobalContext } from "../../../context/globalContext";
import { TkRouteContext } from "../../../context/tkRouteContext";
import { ITkBreadcrumbsItemProps } from "../../../type/componentsType/TkBreadcrumbs";
import TkBreadcrumbs from "../../atoms/TkBreadcrumbs/index";
import { BusinessContext } from "../../../context/businessContext";
import TkSideBar from "../../molecules/TkSideBar";
import { sideBarMenuData } from "./parts";
import {
  authorityUserType,
  pageAccreditationMapping,
} from "../../../assets/data/TkAuthorityProperty";
import SCRC090001 from "../../../pages/SCRC090001";
import { isMobileDevice } from "../../../utils/useTools";
import TkMessageDialog from "../../molecules/TkMessageDialog";

const BeforeMainLayoutRender: React.FC<any> = (props) => {
  const { children } = props;
  const { state } = useContext(GlobalContext);
  let routeList = useConcatRoutes();
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname;
  const route = routeList.find((route) => route.path === path);

  // ホワイトリスト
  const whitelist = ["/error", "/error401", "/temError", "/testLogin"];

  useEffect(() => {
    if (route) {
      if (
        whitelist.indexOf(path) === -1 &&
        (!pageAccreditationMapping[
          path.slice(1) as keyof typeof pageAccreditationMapping
        ] ||
          ((
            pageAccreditationMapping[
              path.slice(1) as keyof typeof pageAccreditationMapping
            ] as string[]
          )[0] !== "*" &&
            !(
              pageAccreditationMapping[
                path.slice(1) as keyof typeof pageAccreditationMapping
              ] as string[]
            ).includes((state.authInfo?.userType ?? "") as string)))
      ) {
        navigate("/error");
      }
    }

    // ブラウザバック・リロードの制御
    const blockBrowserBack = () => {
      window.history.go(1);
      if (!window.history.state) {
        alert(
          "ブラウザの<戻る>機能は利用できません。画面内のボタンを利用下さい。"
        );
        return;
      }
    };
    window.history.pushState(null, "", window.location.href);
    window.addEventListener("popstate", blockBrowserBack);

    const handleBeforeunload = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = ""; // 一部のブラウザでは必要な場合があるため残しておく
    };
    window.addEventListener("beforeunload", handleBeforeunload);

    return () => {
      window.removeEventListener("popstate", blockBrowserBack);
      window.removeEventListener("beforeunload", handleBeforeunload);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path]);

  if (
    route &&
    whitelist.indexOf(path) === -1 &&
    (!pageAccreditationMapping[
      path.slice(1) as keyof typeof pageAccreditationMapping
    ] ||
      ((
        pageAccreditationMapping[
          path.slice(1) as keyof typeof pageAccreditationMapping
        ] as string[]
      )[0] !== "*" &&
        !(
          pageAccreditationMapping[
            path.slice(1) as keyof typeof pageAccreditationMapping
          ] as string[]
        ).includes((state.authInfo?.userType ?? "") as string)))
  ) {
    return <></>;
  }

  return <>{children}</>;
};

/**
 * TkAppのメインレイアウトコンポーネントを表します。
 * @component
 * @param {any} props - コンポーネントのプロパティ。
 * @returns {ReactNode} レンダリングされたメインレイアウトコンポーネント。
 */
export const TkMainLayout: React.FC<any> = (props) => {
  const { state, setState } = useContext(GlobalContext);
  const { state: stateRouter, setState: setStateRouter } =
    useContext(TkRouteContext);
  const { state: businessState, setState: setBusinessStete } =
    useContext(BusinessContext);
  const { children } = props;
  const userType = state?.authInfo?.userType;
  const isShow = userType === authorityUserType.userTypeNumber.KIKO;
  const isKeiyakusya = userType === authorityUserType.userTypeNumber.KEIYAKUSYA;
  const hideButtonBool = !(isShow || isKeiyakusya);
  // ナビゲーションガード
  const location = useLocation();
  let routeList = useConcatRoutes();
  const path = location.pathname;
  const route = routeList.find((route) => route.path === path);

  route?.meta?.title && (document.title = route.meta.title);
  // ナビゲーションガード end
  const [sideBarWidth, setSideBarWidth] = useState(isShow ? 330 : 0);
  const [sideBarData, setSideBarData] = useState<any>(sideBarMenuData);
  const [kikoDepartment, setKikoDepartment] = useState<string>("");
  const [headerName, setHeaderName] = useState<string>("");
  const [errorId, setErrorId] = useState<string>("");
  const [visitedRoutes, setVisitedRoutes] = useState<ITkBreadcrumbsItemProps[]>(
    []
  );
  const navigate = useNavigate();
  const [isOpenRedir, setIsOpenRedir] = useState(false);
  const redrUserMap: any = [
    authorityUserType.userTypeNumber.KIKO,
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.DAIKOSHA,
    authorityUserType.userTypeNumber.FUKUSHI,
  ];
  const redrUser = redrUserMap.includes(userType);

  const scrollRef = useRef<HTMLDivElement>(null);
  const isMobile = isMobileDevice();

  useEffect(() => {
    setErrorId(state?.errorMsgId || "");
    setVisitedRoutes(stateRouter.routerList || []);
    setKikoDepartment(
      `${state.authInfo?.dept || ""}${state.authInfo?.division || ""}`
    );
    setHeaderName(state.authInfo?.name || "");
  }, [state, props, stateRouter]);

  // パンくずのコントロール
  useEffect(() => {
    let resList: ITkBreadcrumbsItemProps[] = [];

    // エラメッセージIDがあると、クリアしします
    if (state.errorMsgId) {
      setState({
        ...state,
        errorMsgId: "",
      });
    }

    const hidePageInBreadcrumb = [
      "/SCRC010001",
      "/SCRC010002",
      "/SCRR410001",
      "/SCRR010001",
      "/SCRR010002",
    ];

    if (path === "/SCRC010003" && route?.meta) {
      route.meta.dnotShowInBreadcrumb = !state?.authInfo?.userType;
      route.meta.isErrorPage = !state?.authInfo?.userType;
    }

    if (hidePageInBreadcrumb.includes(path)) {
      resList = [];
    } else if (route?.meta?.isMenuContent) {
      resList = [
        {
          title: route?.meta?.title || "",
          href: path,
          isErrorPage: route?.meta?.isErrorPage || false,
        },
      ];
      setVisitedRoutes([...resList]);
    } else if (
      !visitedRoutes.some((item) => item.href === path) &&
      !route?.meta?.dnotShowInBreadcrumb &&
      route?.meta?.title
    ) {
      resList = [
        ...visitedRoutes,
        {
          title: route?.meta?.title || "",
          href: path,
          isErrorPage: route?.meta?.isErrorPage || false,
        },
      ];

      setVisitedRoutes([...resList]);
    } else {
      const index = visitedRoutes.findIndex((item) => item.href === path);
      resList = visitedRoutes.slice(0, index + 1);

      setVisitedRoutes([...resList]);
    }

    if (scrollRef.current) {
      scrollRef.current.scrollTo(0, 0);
    }

    setStateRouter({
      routerList: [...resList],
    });

    // 業務フローによって持回りが変わる
    // ホーム画面だと、持回り情報を全クリアする
    //  SCRW110001_機構職員ホーム SCRC020001_共済契約者ホーム SCRD310001_代行者ホーム
    const homeList = ["/SCRC020001", "/SCRD310001"];

    if (homeList.includes(path)) {
      setBusinessStete({});

      return;
    }
    if (path === "/SCRW110001") {
      setBusinessStete({
        searchForHome: businessState.searchForHome,
      });

      return;
    }

    const contextNames = route?.meta?.contextName
      ? (route.meta.contextName.split(",") as Array<keyof typeof businessState>)
      : [];

    let newBusinessState = {};
    if (contextNames && contextNames.length === 0) {
      newBusinessState = {
        common: businessState.common,
      };
    } else {
      newBusinessState = contextNames.reduce((acc, contextName) => {
        return {
          ...acc,
          [contextName as string]: businessState[contextName],
        };
      }, {});
      setBusinessStete({
        common: businessState.common,
        ...newBusinessState,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path]);

  const [mainClassName, setMainClassName] = useState("tkMainLayout");

  // サイドバーのコントロール
  const handleSideBarWidth = (width: any) => {
    if (isShow) {
      switch (width) {
        case 330:
          setMainClassName("tkMainLayout activeLong");
          break;
        case 75:
          setMainClassName("tkMainLayout activeShort");
          break;
      }
      setSideBarWidth(width);
    } else {
      setMainClassName("tkMainLayout");
    }
  };

  useEffect(() => {
    if (isShow) {
      setSideBarData(sideBarMenuData);
      setMainClassName("tkMainLayout activeLong");
    } else {
      setMainClassName("tkMainLayout");
    }

    const handleDialogOpen = () => {
      setIsOpenRedir(true);
    };

    // タイムアウト時のダイアログ表示
    window.addEventListener("tkApiRequestTimeout", handleDialogOpen);

    return () => {
      window.removeEventListener("tkApiRequestTimeout", handleDialogOpen);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCloseDialog = () => {
    setIsOpenRedir(false);
    switch (userType) {
      case authorityUserType.userTypeNumber.KIKO:
        navigate("/SCRW110001");
        break;
      case authorityUserType.userTypeNumber.KEIYAKUSYA:
        navigate("/SCRC020001");
        break;
      case authorityUserType.userTypeNumber.DAIKOSHA:
        navigate("/SCRD310001");
        break;
      case authorityUserType.userTypeNumber.FUKUSHI:
        navigate("/SCRS080001");
        break;
    }
  };

  return (
    <>
      {/* サイドバー */}
      <Box className="tkSideBarCss">
        <TkSideBar
          getWidth={handleSideBarWidth}
          data={sideBarData}
          userType={userType}
        ></TkSideBar>
      </Box>
      <Box
        data-testid="tkMainLayoutForTest"
        className={mainClassName}
        ref={scrollRef}
      >
        {/* メイン */}
        <Box className="mainSection">
          {/* ヘッダー */}
          <Box className="headerSection">
            <TkHeader
              userType={userType}
              sideBarWidth={sideBarWidth}
              title={route?.meta?.title || ""}
              hideButton={route?.meta?.isErrorPage || hideButtonBool || false}
              department={kikoDepartment}
              headerName={headerName}
            />
          </Box>
          {/* パンくず */}
          {visitedRoutes.length > 0 &&
          !visitedRoutes[visitedRoutes.length - 1]?.isErrorPage ? (
            <Box className="breadcrumbsSec">
              <Box className="breadcrumbs">
                <TkBreadcrumbs list={visitedRoutes} />
              </Box>
            </Box>
          ) : (
            <></>
          )}
          {/*　注意事項 */}
          <Box
            className={`noticeSectionSec ${
              visitedRoutes.length === 0 ? "tkNoBreadCrumb" : ""
            }`}
            style={{
              width: `calc(100vw - ${
                userType === authorityUserType.userTypeNumber.KIKO
                  ? sideBarWidth + 0
                  : 0
              }px)`,
              transition: "width 0.3s",
            }}
          >
            <Box
              className="noticeSection"
              style={{
                overflowY: "auto",
              }}
            >
              {isMobile
                ? "ブラウザの<戻る>、<更新>機能は利用できません。画面内のボタンを利用下さい。"
                : "ブラウザの「戻るボタン」及び「更新ボタン」は使用できません。前の画面に戻る場合は、画面上部にあるリンクを押下してください。"}
            </Box>
          </Box>

          {/* メッセージバー */}
          {errorId && (
            <Box data-testid="messageBarForTestBox" className="massageSection">
              <Box
                style={{
                  width: `calc(100% - ${
                    userType === authorityUserType.userTypeNumber.KIKO
                      ? sideBarWidth
                      : 0
                  }px)`,
                }}
                className={`tkMassageBar ${
                  visitedRoutes.length === 0 && "tkNoBreadCrumb"
                }`}
              >
                <HandleErrorMessage id={errorId} value={state.errorMsgValues} />
              </Box>
            </Box>
          )}

          {/* コンテンツ */}
          <Box className={`mainContext ${errorId && "isError"}`}>
            <BeforeMainLayoutRender children={children} />
          </Box>

          {/* チャットボット */}
          <SCRC090001 />

          {/* フッター */}
          <TkFooter userType={userType} pagePath={path} />

          <TkMessageDialog
            contextText="処理に時間がかかっていますが、進行していますので、再実行はせずに、時間をおいてからご確認をお願いします。"
            open={isOpenRedir}
            onOky={handleCloseDialog}
            okText={redrUser ? "ホームに戻る" : ""}
            cancelText=""
          />
        </Box>
      </Box>
    </>
  );
};

export default TkMainLayout;
